module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w5-field text-search"
  }, [_c('span', {
    staticClass: "al",
    class: {
      'animated': _vm.fieldAnimated, 'focused': _vm.Focused || !_vm.Empty, 'unfocused': !_vm.Focused && _vm.Empty
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Title))), _c('span', {
    staticClass: "required-field"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "inputComponent",
    staticClass: "input-text",
    attrs: {
      "type": "text",
      "placeholder": _vm._f("ftc")('mails/templates')
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }, _vm.searchText],
      "focus": function($event) {
        return _vm.setFocus(true)
      },
      "blur": function($event) {
        return _vm.setFocus(false)
      },
      "click": _vm.init
    }
  }), _vm._v(" "), _c('div', {
    ref: "listItems",
    staticClass: "items-wrapper scrollable"
  }, [_vm._l((_vm.foundItems), function(item) {
    return _c('div', {
      staticClass: "found-item scrollable",
      on: {
        "click": function($event) {
          return _vm.selectText(item.name)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRequest),
      expression: "isRequest"
    }],
    staticClass: "found-item"
  }, [_vm._v(_vm._s(_vm._f("ftc")('text/find_templates')))])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0b78ea8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/text.vue
// module id = 668
// module chunks = 0